// extracted by css-extract-rspack-plugin
export default {"iconLabel":"iconLabel-g2vAe8","tips":"tips-pLSRlv","more":"more-fzFxCD","arrow":"arrow-ffWPg0"};